import categories from "../../../Forms/categories.json";
import activities from "../../../Forms/activities.json";

const useActivitiesOfSector = (secteurId) => {
  const sector = categories.find((cat) => cat.id == secteurId);

  // Si le secteur n'existe pas, retourner null
  if (!sector) return { activitiesFiltered: [] };

  // Obtenir toutes les activités du secteur
  const activitiesFiltered = activities.filter(
    (a) => a.rootCategoryId == secteurId
  );

  return { activitiesFiltered };
};

export default useActivitiesOfSector;
